import React from "react";

interface IYandexIconProps {
    sizeX?: number;
    sizeY?: number;
}

export const YandexIcon: React.FC<IYandexIconProps> = ({ sizeX = 13, sizeY = 20 }) => {
    return (
        <svg width={sizeX} height={sizeY} viewBox="0 0 13 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M9.42043 19.2H12.7632V0H7.90101C3.01122 0 0.442014 2.51396 0.442014 6.21583C0.442014 9.1718 1.85094 10.9122 4.36489 12.7079L0 19.2H3.61899L8.48115 11.9344L6.79597 10.8017C4.75166 9.42043 3.75712 8.34302 3.75712 6.02245C3.75712 3.97813 5.19367 2.59684 7.92863 2.59684H9.42043V19.2Z"
                fill="#D0BDF8"/>
        </svg>
    );
}
